import * as Yup from 'yup';
import i18n from 'i18next';
import { phoneRegExp } from 'globalutils/constants';

export const schema = Yup.object().shape({
  companyName: Yup.string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .test('len', 'Must have atleast 4 characters', (val) => val && val.length > 3),
  address: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  state: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  city: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  zipCode: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  companyPhone: Yup.string().matches(phoneRegExp, i18n.t('common.validNumFormat')).required(i18n.t('common.fieldRequiredMessage')),
  dotNumber: Yup.number().typeError('Please use numbers with maximum length 9').required(i18n.t('common.fieldRequiredMessage')),
  initialTrucks: Yup.number()
    .typeError('Please use integers with maximum length 3')
    .required(i18n.t('common.fieldRequiredMessage'))
    .min(1, 'Please enter a valid integer value')
    .integer('Please enter valid integer'),
});
